import React, { useState } from "react";
import { AiOutlineMinus } from "react-icons/ai";

const TextInputTag = ({
  label,
  length,
  name,
  defaultValue,
  multiple,
  required,
  disabled,
}) => {
  const [visibility, setVisibility] = useState(true);

  const handleDelete = () => {
    setVisibility(false);
  };
  return (
    <div
      key={Math.random()}
      className={visibility ? "flex gap-1 items-end w-full" : "hidden"}
    >
      <div className="w-full">
        <label htmlFor={name} className="label capitalize">
          <span className="text-md font-semibold">
            {multiple && length ? label + " " + length : label}
          </span>
        </label>
        <textarea
          row={10}
          name={visibility ? name : ""}
          defaultValue={defaultValue}
          type="Text"
          className="textarea my-2 textarea-bordered h-[150px] w-full border border-gray-300 rounded-md px-3 py-2 disabled:cursor-not-allowed"
          required={required}
          id={name}
          disabled={disabled}
        />
      </div>
      <div className={!multiple && "hidden"}>
        <button
          type="button"
          onClick={handleDelete}
          className="btn  btn-sm btn-circle"
        >
          <AiOutlineMinus />
        </button>
      </div>
    </div>
  );
};

export default TextInputTag;
